import { CookieService } from './cookie.service';
import { AutenticacaoDto } from './modelos/autenticacao-dto';
import { Usuario } from './modelos/usuario';
import jwtDecode from 'jwt-decode';


export class UserManager {
    private _cookie: CookieService;

    constructor() {
        this._cookie = new CookieService();
    }

    consultarUsuario(): Usuario | null {
        try {
            let autenticacao = this.consultarAutenticacao();

            if(autenticacao === null)
                return null;

            let user = jwtDecode(autenticacao.token.token) as Usuario;

            user.profissionalProfissaoTipo = +user.profissionalProfissaoTipo;
            user.profissionalTipoAssinatura = +(user.profissionalTipoAssinatura ?? 1);
            user.empresaId = +user.empresaId;
            user.id = +user.id;
            user.profissionalId = +user.profissionalId;

            return user;
        } catch (error) {
            return null;
        }
    }

    consultarAutenticacao(): AutenticacaoDto | null {
        let autenticacao = localStorage.getItem('autenticacao') ?? '';

        if(!autenticacao) {
            autenticacao = this._cookie.consultar('autenticacao');
        }

        return autenticacao ? JSON.parse(autenticacao) : null;
    }
}